"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const payment_1 = require("../../../model/payment");
const helpers_1 = require("../../../utils/helpers");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const notification_center_1 = require("../../../widgets/notification_center");
const contract_table_1 = require("../contract/contract_table");
const payment_table_1 = require("./payment_table");
const moment = require("moment");
function renderForm(form) {
    return form.fieldset("", {}, form.selectField("Type", "payment_type", payment_1.PAYMENT_TYPES), form.field("Dû le", "due_at", "date", {
        renderValue: (date) => {
            return moment(date).format("YYYY-MM-DD");
        },
        transformValue: (date) => {
            return moment(date, "YYYY-MM-DD").format();
        }
    }), form.checkbox("Payé ? ", "paid"), (0, helpers_1.ifTrue)(form.obj.paid, form.field("Payé le", "paid_at", "date", {
        renderValue: (date) => {
            return moment(date).format("YYYY-MM-DD");
        },
        transformValue: (date) => {
            if (date)
                return moment(date, "YYYY-MM-DD").format();
            return undefined;
        }
    })));
}
exports.PaymentForm = {
    active: false,
    payment: {},
    title(form) {
        return `Editer paiement ${form.obj.id}`;
    },
    view(_vnode) {
        if (this.active) {
            let form = (0, form_for_1.formFor)(this.payment, payment_1.PaymentProvider, (form) => {
                return (0, modal_1.modalCard)({
                    title: this.title(form),
                    content: renderForm(form),
                    foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit(form.isNew() ? "Créer" : "Mettre à jour", {
                        onsubmit: (_obj) => {
                            notification_center_1.Notification.success(`Le paiement #${this.payment.id} a bien été mis à jour.`);
                            contract_table_1.ContractTable.fetch();
                            payment_table_1.PaymentsTable.fetch();
                            exports.PaymentForm.active = false;
                        }
                    })),
                    isActive: exports.PaymentForm.active,
                    onClose: () => { exports.PaymentForm.active = false; }
                });
            });
            return form;
        }
        return undefined;
    },
    show(payment) {
        this.payment = payment;
        this.active = true;
    },
};
